import { createAction } from 'actions/utils';
import {
    CLEAR_CURRENT_USER,
    GET_IMPL_SUMMARY_REQUEST,
    GET_IMPL_SUMMARY_SUCCESS,
    GET_IMPL_SUMMARY_ERROR,
    GET_SSO_PROVIER_REQUEST,
    GET_SSO_PROVIER_SUCCESS,
    GET_SSO_PROVIER_ERROR,
    GET_USERS_HIERACHY_REQUEST,
    GET_USERS_HIERACHY_SUCCESS,
    GET_USERS_HIERACHY_ERROR,
    GET_USER_REQUEST,
    GET_USER_SUCCESS,
    GET_USER_ERROR,
    GET_USER_SCHEMA_REQUEST,
    GET_USER_SCHEMA_SUCCESS,
    GET_USER_SCHEMA_ERROR,
    GET_USER_COUNTRY_CODES_REQUEST,
    GET_USER_COUNTRY_CODES_SUCCESS,
    GET_USER_COUNTRY_CODES_ERROR,
} from 'constants/ActionTypes';
import { Core } from 'managers';

export function getImplSummary() {
    return (dispatch) => {
        dispatch(createAction(GET_IMPL_SUMMARY_REQUEST, {}));
        return Core.usersManager.getImplSummary().then(
            (res) => {
                dispatch(createAction(GET_IMPL_SUMMARY_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_IMPL_SUMMARY_ERROR, error));
                throw error;
            },
        );
    };
}

export function getUsersHierachy() {
    return (dispatch) => {
        dispatch(createAction(GET_USERS_HIERACHY_REQUEST, {}));
        return Core.usersManager.getUsersHierachy().then(
            (res) => {
                dispatch(createAction(GET_USERS_HIERACHY_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_USERS_HIERACHY_ERROR, error));
                throw error;
            },
        );
    };
}

export function getUser({ id }) {
    return (dispatch) => {
        dispatch(createAction(GET_USER_REQUEST, {}));
        return Core.usersManager.getUser(id).then(
            (res) => {
                dispatch(createAction(GET_USER_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_USER_ERROR, error));
                throw error;
            },
        );
    };
}

export function clearCurrentUser() {
    return (dispatch) => {
        dispatch(createAction(CLEAR_CURRENT_USER, {}));
    };
}

export function getUserSchema() {
    return (dispatch) => {
        dispatch(createAction(GET_USER_SCHEMA_REQUEST, {}));
        return Core.usersManager.getUserSchema().then(
            (res) => {
                dispatch(createAction(GET_USER_SCHEMA_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_USER_SCHEMA_ERROR, error));
                throw error;
            },
        );
    };
}

export function getPasswordPolicies() {
    return () => Core.usersManager.getPasswordPolicies();
}

export function getSSOProvider() {
    return (dispatch) => {
        dispatch(createAction(GET_SSO_PROVIER_REQUEST, {}));
        return Core.usersManager.getSSOProvider().then(
            (res) => {
                dispatch(createAction(GET_SSO_PROVIER_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_SSO_PROVIER_ERROR, error));
                throw error;
            },
        );
    };
}

export function getCountryCodes() {
    return (dispatch) => {
        dispatch(createAction(GET_USER_COUNTRY_CODES_REQUEST, {}));
        return Core.usersManager.getCountryCodes().then(
            (res) => {
                dispatch(createAction(GET_USER_COUNTRY_CODES_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_USER_COUNTRY_CODES_ERROR, error));
                throw error;
            },
        );
    };
}

export function toggleActivateUser(id, isActive) {
    return () => Core.usersManager.toggleActivateUser(id, isActive);
}

export function deleteUser(id) {
    return () =>
        new Promise((resolve, reject) => {
            Core.usersManager.deleteUser(id).then(
                (res) => {
                    if (res && res.id > 0 && res.status === true) {
                        resolve(res);
                    } else {
                        reject();
                    }
                },
                (error) => {
                    reject(error);
                },
            );
        });
}
